<script>
import { fandomTranslate } from "src/modules/common_module";
import { get } from 'lodash';

export default {
  data: function() {
    return {
      content: null,
      containerContent: null,
      pageModel: globalState.pageModel,
    };
  },
  mounted() {
    Vue.nextTick(() => {
      Fandom.onEvent('modal-user-form', (data) => {
        Vue.set(this, 'content', data.content);
        Vue.set(this, 'containerContent', data.containerContent);
        $("#user-modal-form").modal("show");
      });
    });
  },
  methods: {
    ft: fandomTranslate,
    updateUserModel(data) {
      $("#user-modal-form").modal("hide");
      console.log(data);
      const updatedInfo = get(data, ["user_upload_interaction", "user_upload_interaction_params"], []);
      Object.keys(updatedInfo).forEach(efName => {
        Vue.set(globalState.pageModel.user, efName, updatedInfo[efName]);
      });
    }
  },
  computed: { }
};
</script>

<template>
  <div modal-user-form-component modal-components>
    <div id="user-modal-form" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header border-bottom-0 pb-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center" registration-pages>
            <div class="row justify-content-center">
              <div class="col-lg-10" v-if="content">
                <img :src="content.image.url" v-if="content.image" class="img-fluid mb-4"/>
                <h5 class="modal-title h3 font-weight-bold mb-3">{{content.title}}</h5>
                <div v-if="content.description" class="user-edit-description" v-html="content.description"></div>
                <generic-form class="my-5 text-left" :content="content" :opt-container-content="containerContent" @done="updateUserModel"></generic-form>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>